<template>
	<section>
		<h2>{{ $t("global.prices") }}</h2>

			<b-row>
				<b-col class="table-responsive">
					<b-table striped hover :items="itemsPrices" :fields="fieldsPrices">
						<template #thead-top="">
							<b-tr>
								<b-th></b-th>
								<b-th></b-th>
								<b-th></b-th>
								<b-th></b-th>
								<b-th :variant="variantsByTotal.supplier"  class="text-right">{{ $t("bookings.price") }}</b-th>

							</b-tr>
						</template>
						
						<template #cell(lblSupplierPriceTotal)="row">
							<div class="d-flex flex-row justify-content-end">
								<div>
									<span>{{row.item.lblSupplierPriceTotal}}</span>
									<div><small>{{row.item.supplierPriceOverride ? $t("bookings.rateLocked") : ''}}</small></div>
								</div>
								<md-icon
									@click.native="openEditPrice(row.item.id, 'supplier')"
									class="ml-2 text-info edit-icon"
									icon="edit"></md-icon>
							</div>
						</template>
						<template #cell(status)="row">
							{{ $t("bookings.serviceStatusOpts."+row.item.status) }}
						</template>
						<template #custom-foot>
							<b-tr>
								<b-th></b-th>
								<b-th></b-th>
								<b-th></b-th>
								<b-th></b-th>
								<b-th :variant="variantsByTotal.supplier" class="text-right pb-0">
									<p class="mt-1" v-for="(item, i) of totalsSupplier" :key="i">
										{{formatLblPrice(item.total,item.currency)}}
									</p>
								</b-th>

							</b-tr>
						</template>
					</b-table>
				</b-col>
			</b-row>

		<b-overlay :show="loading" no-wrap rounded></b-overlay>
		<b-modal
		size="lg"
		scrollable
		no-fade
		:title="`Editar ${type[formType]}`"
		ref="modal-edit-price"
		body-class="position-static"
		hide-footer
		no-close-on-backdrop
		>
			<form-edit-price
			:type="type"
			:transportServiceId="transportServiceId"
			:formType="formType"
			@saved="saved"
			/>
		</b-modal>
	</section>
</template>

<script>
	import api from '../../../api.js'
	//	import numeral from 'numeral'
	import formEditPrice from "./FormEditPrice.vue"
	export default {
		components: {formEditPrice  },
		props: {
			modelId: {
				type : Number,
				required: true,
			}
		},
		data(){
			return {
				type: {
					booking: 'Precio de venta',
					net: 'Precio tarifa',
					supplier:  this.$t("bookings.price") 
				},
				formType: null,
				transportServices:[],
				loading:true,
				totalTypes:["supplier"],
				variantsByTotal:{booking:"success",net:"primary",supplier:"info"},
				transportServiceId:-1
			}
		},
		computed : {
			fieldsPrices(){
				let fields = [
					{label: "# "+this.$t("bookings.service"),key:"serviceNumber"},
					{label: this.$t("bookings.tripType"),key:"tripType"},
					{label:this.$t("global.date"),key:"pickupDatetime"},
					{label:"Status",key:"status"},
					{label:"Total c/imp",key:"lblSupplierPriceTotal",class:"text-right"},
				];
				return fields;
			},
			itemsPrices(){
				let items = [];
				this.transportServices.forEach((ts)=>{
					let toAdd       = {
						lblSupplierPriceSubtotal  :this.formatLblPrice(ts.supplierPriceSubtotal,ts.supplierCurrency),
						lblSupplierPriceTotal	  :this.formatLblPrice(ts.supplierPriceTotal,ts.supplierCurrency),
					}
					let item =  {...ts,...toAdd}
					items.push(item)
				})
				return items;
			},
			totalsByCurrency(){//sacamos el total por currency
				let info   = {booking:{},net:{},supplier:{}};

				this.totalTypes.forEach((_type)=>{
					this.transportServices.forEach((ts)=>{
						let tsCurrency = ts[`${_type}Currency`].toLowerCase();
						if(info[_type][tsCurrency]===undefined){
							info[_type][tsCurrency]= {//se iniciliza el index
								currency:`${tsCurrency}`,
								// subtotal:0,
								total:0
							};
						}
						// info[_type][tsCurrency].subtotal = info[_type][tsCurrency].subtotal+=Number(ts[`${_type}PriceSubtotal`]);
						info[_type][tsCurrency].total    = info[_type][tsCurrency].total+=Number(ts[`${_type}PriceTotal`]);
					})
				})

				let result = {};
				this.totalTypes.forEach((_type)=>{
					result[_type] = Object.values(info[_type]);
				})
				return result;
			},
			
			totalsSupplier(){
				return this.totalsByCurrency.supplier;
			},/*
			colspanBookingPrice(){
				let colspan =  ((this.$hasPermission('reservation.specialPrice'))?'3':'2');
				return colspan
			} */
		},
		methods:{
			fetchModel(){
				this.loading = true
				api(this).get(`/reservations/prices-summary/${this.modelId}`).then( res => {
					this.transportServices = Array.isArray(res.data) ? [...res.data] : [...res.data.transportServices]
					this.loading = false
				}).catch(this.$root.handleRequestError);
			},
			formatLblPrice(price,currency){
				return "$"+price +" "+(currency.toUpperCase())
				//	let priceF =  numeral(price).format('0,0.[00]');
				//	return "$"+priceF +" "+(currency.toUpperCase())

			},
			openEditPrice(transportServiceId, type){
				this.transportServiceId = transportServiceId;
				this.formType = type
				this.$refs["modal-edit-price"].show();
			},
			closeEditPrice(){
				this.$refs["modal-edit-price"].hide();
			},
			saved(){
				this.closeEditPrice();
				this.fetchModel()

			}

		},
		mounted(){
			this.fetchModel()

		}
	}
</script>

<style scoped>
	.price-input{
		width: 40px;
	}
	.edit-icon {
		cursor: pointer;
	}
</style>
